import React from "react";

/**
 * R6 A5 — Row density toggle.
 * Compact=32px, Comfortable=44px (default), Roomy=60px.
 */
const LEVELS = [
  { key: "compact", label: "Compact" },
  { key: "comfortable", label: "Comfortable" },
  { key: "roomy", label: "Roomy" },
];

export default function DensityToggle({ value, onChange }) {
  return (
    <div className="r6-density-toggle">
      {LEVELS.map((l) => (
        <button
          key={l.key}
          type="button"
          className={`r6-density-btn ${value === l.key ? "is-active" : ""}`}
          onClick={() => onChange?.(l.key)}
          title={l.label}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}